export enum SectionTagColors {
  GREEN = 'green',
  BLUE = 'blue',
}
